function noticeTouch() {
    window.removeEventListener('touchstart', noticeTouch);
    // OMG this is not supported  by all browsers!
    // But it's supported by all browsers with touch support
    document.body.classList.remove('notouch');
    // this solution sucks anyway
    // http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
    // also see: caniuse.com touch events IE/Edge :(

    // the only reliable detection of touch would be to look for behavior that only mouse can do.
    // you'll have to wait till I create an oss lib for that
}

export default function touchy() {
    window.addEventListener('touchstart', noticeTouch);
}
